"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _reactGa = _interopRequireDefault(require("react-ga4"));

var _matomoTracker = _interopRequireDefault(require("@jonkoops/matomo-tracker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Tracking {
  constructor(_ref) {
    var _this = this;

    let {
      enabled,
      gaId,
      mtId,
      mtUrl,
      debug
    } = _ref;

    _defineProperty(this, "greetTheWorld", () => {
      this.log("Hello World");
    });

    _defineProperty(this, "log", function () {
      if (_this.debug) {
        console.log(...arguments);
      }
    });

    _defineProperty(this, "trackEvent", (category, action) => {
      this.log("firing 'trackEvent'");

      if (this.enabled) {
        if (this.gaId) {
          _reactGa.default.event({
            category,
            action
          });
        }

        if (this.mtId && this.mtUrl) {
          this.matomo.trackEvent({
            category,
            action
          });
        }
      }
    });

    _defineProperty(this, "trackDetailedEvent", _ref2 => {
      let {
        category,
        action,
        name,
        value
      } = _ref2;

      if (this.enabled) {
        if (this.mtId && this.mtUrl) {
          this.matomo.trackEvent({
            category,
            action,
            name,
            value
          });
        }
      }
    });

    _defineProperty(this, "trackPageView", () => {
      this.log("firing 'trackPageview'");

      if (this.enabled) {
        if (this.mtId && this.mtUrl) {
          this.matomo.trackPageView();
        }
      }
    });

    _defineProperty(this, "trackException", message => {
      this.log("firing 'trackException'");

      if (this.enabled) {
        if (this.gaId) {
          _reactGa.default.event('exception', {
            description: message,
            fatal: true
          });
        }

        if (this.mtId && this.mtUrl) {
          this.matomo.trackEvent({
            category: "Exception",
            action: message
          });
        }
      }
    });

    _defineProperty(this, "trackEcommerce", (transactionId, items) => {
      this.log("firing 'trackEcommerce'");

      if (this.enabled) {
        if (this.gaId) {
          const transactionItems = items.map(_ref3 => {
            let {
              id,
              name,
              category
            } = _ref3;
            return {
              item_id: id,
              item_name: name,
              item_category: category
            };
          });

          _reactGa.default.event('purchase', {
            transaction_id: transactionId,
            items: transactionItems
          });
        }

        if (this.mtId && this.mtUrl) {
          items.forEach(_ref4 => {
            let {
              id,
              name,
              category,
              sku
            } = _ref4;
            this.matomo.addEcommerceItem({
              sku,
              productName: name,
              productCategory: category
            });
          });
          this.matomo.trackEcommerceOrder({
            orderId: transactionId,
            orderRevenue: 0
          });
        }
      }
    });

    const isBrowser = typeof window !== "undefined";
    this.enabled = enabled;
    this.gaId = gaId;
    this.mtId = mtId;
    this.mtUrl = mtUrl;
    this.debug = debug;

    if (!isBrowser) {
      this.enabled = false;
    }

    if (this.enabled) {
      _reactGa.default.initialize([{
        trackingId: gaId,
        debug
      }]);

      _reactGa.default.ga("set", "anonymizeIp", true);

      this.google = _reactGa.default;
      this.matomo = new _matomoTracker.default({
        urlBase: mtUrl,
        siteId: mtId
      });
    }
  }

}

var _default = Tracking;
exports.default = _default;